import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VTextField,{directives:[{name:"mask",rawName:"v-mask",value:(_vm.TimeMask),expression:"TimeMask"}],staticClass:"shrink",attrs:{"placeholder":"00:00-23:59","label":_vm.title,"clearable":_vm.clearable,"readonly":_vm.readonly,"hide-details":"auto","dense":"","outlined":""},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})
}
var staticRenderFns = []

export { render, staticRenderFns }